<template>    
    <div>
        <ModuleMenu :moduleKey="module_key" />
        <v-container class="listing" style="margin: 0 auto; max-width: 1264px;">
            <v-dialog v-model="feedbackDialog" width="72%" elevation="8" dark fade>
                <v-card :color="feedback_type">
                    <div class="headline text-center py-4">{{ feedback_msg }}</div>
                </v-card>
            </v-dialog>

            <div class="">
                <h1>What to Expect When Aquiring with SRG's Seller Advocacy Program</h1>
                <p>Should you become a buyer with SRG, you can expect the timeline as follows: You can download a pdf version of the <a href="https://cdn2.hubspot.net/hubfs/6155808/Website%20Images/Seller%20Advocacy%20Timeline%20for%20Buyers%20v2020.pdf" target="_blank" class="button_link">timeline here</a>.</p>
            </div>

            <div class="mt-12 d-flex">
                <v-row justify="space-around">
                    <v-col cols="2">
                        <h3>Phase 1</h3>
                        <p>4-6 weeks</p>
                    </v-col>
                    <v-col cols="5" class="">
                        <ul class="phase_steps">
                            <li class="phase_steps_active"><div class="active_box" style="float: left">Become a Buyer: Buyer Profile</div><div class="active_box_point" style="float: left"></div></li>
                            <li class="phase_steps">Find a listing: Express Interest</li>
                            <li class="phase_steps">NDA/Engagement Agreement</li>
                            <li class="phase_steps">Intake CAll with SRG</li>
                        </ul>
                    </v-col>
                    <v-col cols="5" class="">
                        <h3>Buyer Profile</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In mollis tempus ultrices. Mauris porttitor mattis orci molestie scelerisque.</p>
                        <router-link to="/module_questionnaire/buyer" push class="button_link"><v-btn class="my-4" color="accent" style="color: #37383C">Complete Buyer Profile</v-btn></router-link>
                    </v-col>
                </v-row>
            </div>

            <div class="mt-6 d-flex">
                <v-row justify="space-around">
                    <v-col cols="2">
                        <h3>Phase 2</h3>
                        <p>4-6 weeks</p>
                    </v-col>
                    <v-col cols="5" class="">
                        <ul>
                            <li class="phase_steps">Seller Introduction Phone</li>
                            <li class="phase_steps">Seller Introduction Face to Face</li>
                            <li class="phase_steps">Offer Letter</li>
                        </ul>
                    </v-col>
                    <v-col cols="5" class="">
                        <h3></h3>
                        <p></p>
                        <!-- <router-link to="/buyer_module/6" push class="button_link"><v-btn class="my-4" color="#0096a6" dark outline>Buyer Profile</v-btn></router-link> -->
                    </v-col>
                </v-row>
            </div>

            <div class="mt-6 d-flex">
                <v-row justify="space-around">
                    <v-col cols="2">
                        <h3>Phase 3</h3>
                        <p>8-14 weeks</p>
                    </v-col>
                    <v-col cols="5" class="">
                        <ul>
                            <li class="phase_steps">Due Diligence and Lending</li>
                            <li class="phase_steps">Purchase Agreements</li>
                            <li class="phase_steps">Close and Fund</li>
                        </ul>
                    </v-col>
                    <v-col cols="5" class="">
                        <h3></h3>
                        <p></p>
                        <!-- <router-link to="/buyer_module/6" push class="button_link"><v-btn class="my-4" color="#0096a6" dark outlined>Buyer Profile</v-btn></router-link> -->
                    </v-col>
                </v-row>
            </div>

            <div class="mt-6 d-flex">
                <h4 class="mt-6">Total Time: 3-7 months</h4>
            </div>
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import { mdiMagnify, mdiChevronDown, mdiChevronUp, mdiHeartCircleOutline, mdiHeart } from '@mdi/js'
    let dateFormat = require('dateformat');

    import ModuleMenu from './ModuleMenu'

    export default {
        name: 'BuyerMilestones',
        components: {
            ModuleMenu
        },
        data () {
            return {
                module_key: 'buyer',
                listings: [],
                filteredListings: [],
                search: '',
                icons: {
                    chevronDownIcon: mdiChevronDown,
                    chevronUpIcon: mdiChevronUp,
                    magnifyIcon: mdiMagnify,
                    heartIcon: mdiHeart,
                    heartCircleIcon: mdiHeartCircleOutline
                },
                listing_statuses: [
                    {   value: 1, text: 'Open', filter: 'open_listings' },
                    {   value: 2, text: 'Pending', filter: 'pending_listings' },
                    {   value: 3, text: 'Sold', filter: 'sold_listings' },
                    {   value: 4, text: 'Closed', filter: 'closed_listings' },
                ],

                feedbackDialog: false,
                feedback_type: '',
                feedback_msg: '',

            }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            listings () {
                this.filterListingsByStatus();
            }
        },
        mounted () {
            //this.getListings() 
        },
        methods: {

            getListings: async function () {
                await this.getLists()

                setTimeout(() => {
                    axios.post(`${appUrls.api}/api/listings`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            'user_id': Cookie.get('id')
                        }
                    })
                    .then( res => {
                        if(res.data.outcome){
                            //console.log()
                            this.listings = res.data.listings;
                            let i = 0;
                            for( let listing of this.listings ) {
                                this.listings[i].post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                                this.listings[i].listing_type = parseInt(this.listings[i].listing_type);
                                this.listings[i].status       = parseInt(this.listings[i].status);
                                
                                // LOCATION MODIFICATION
                                let vLoc = '';
                                if(listing.city !== '' && listing.state !== '') {
                                    vLoc = `${listing.city}, ${listing.state}`;
                                } else if(listing.city == '' && listing.state !== '') {
                                    vLoc = listing.state;
                                } else if(listing.city !== '' && listing.state == '') {
                                    vLoc = listing.city;
                                }
                                this.listings[i].location = vLoc;

                                // STATUS
                                let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status);
                                this.listings[i].status_name = statusObj.text;

                                // TYPE NAME
                                let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                                this.listings[i].type_name = typeObj.text;

                                // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                                let has_record = res.data.actions.find(row => row.listing_id === this.listings[i].id) ? true : false;
                                let interest_record = has_record ? res.data.actions.find(row => row.listing_id === this.listings[i].id) : false;

                                // INTERESTED
                                //console.log('has_record: '+has_record)
                                this.listings[i].interested = has_record ? true : false;

                                this.listings[i].interest_toggle = has_record ? "notshow" : "show";
                                this.listings[i].interest_type   = has_record ? "error" : "#0096a6";
                                this.listings[i].interest_text   = has_record ? "I'm Interested" : "Express Interest";

                                // OFFER
                                //console.log('interest_record.offer: '+interest_record.offer)
                                this.listings[i].offer_made = interest_record ? interest_record.offer ? true : false : false;
                                this.listings[i].offer_type = interest_record ? interest_record.offer ? "error" : "#0096a6" : "#0096a6";
                                this.listings[i].offer_text = interest_record ? interest_record.offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                                // FAV
                                this.listings[i].fav        = interest_record ? interest_record.fav ? true : false : false;
                                this.listings[i].fav_color  = interest_record ? interest_record.fav ? "#e04b4b" : "#909090" : "#909090";

                                i++;
                            }
                            console.log(this.listings)
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }, 1500);
            },
            
            getLists: function () {
                let optionsLists = [ {'name': 'listing_types', 'type': 'int'}, {'name': 'buyer_status', 'type': 'int'}, {'name': 'states', 'type': 'txt'}];
                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            filterListingsByStatus: async function () {
                //console.log('filterListingsByStatus: triggered')
                let listing_status = [];
                this.filteredListings = this.listings;

                // for ( let obj in this.filterby) {
                //     console.log(obj)
                //     if( obj === true ) {
                //         id = this.listing_statuses.filter(row => {
                //             return 
                //         });
                //     }
                // }

                // if( this.filterby.open_listings ) {
                //     listing_status.push(1);
                // }

                // if( this.filterby.pending_listings ) {
                //     listing_status.push(2);
                // }

                // if( this.filterby.sold_listings ) {
                //     listing_status.push(3);
                // }

                // if( this.filterby.closed_listings) {
                //     listing_status.push(4);
                // }
                
                //console.log(listing_status)
                // FILTERING MAGIC BASED ON STATUS
                // this.filteredListings = this.listings.filter(row => {
                //     return listing_status.includes(parseInt(row.status)) === true
                //});
                //console.log(this.filteredListings);
            },
            
            showDesc (item) {
                // console.log(item)
                this.$set(this.filteredListings[this.filteredListings.indexOf(item)], 'show', !item.show);
                //console.log(this.filteredListings)
            },

            favLisitng ( item ) {
                axios.post(`${appUrls.api}/api/fav_listing`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'user_id': Cookie.get('id'),
                        'listing': item
                    }
                })
                .then( res => {
                    console.log(res.data.message)
                    this.getListings()
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            listingActions ( action, toggle, listingId ) {
                axios.post(`${appUrls.api}/api/listing_actions`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'action': action,
                        'toggle': toggle,
                        'user_id': Cookie.get('id'),
                        'listing_id': listingId
                    }
                })
                .then( res => {
                    this.getListings()
                    switch (res.data.toggle) {
                        case 'show':
                            // SUCCESS DIALOG W/ MESSAGE
                            this.feedback_type = 'error'
                            break;
                        case 'notshow':
                            // FAILED DIALOG W/ MESSAGE
                            this.feedback_type = 'info'
                            break;
                    }
                    let thisOne = this.filteredListings.find(row => row.id === listingId)
                    this.feedback_msg = res.data.message+' '+thisOne.listing_id;
                    this.feedbackDialog = true;
                    this.closeFeedbackDialog()
                })
                .catch(function (error) {
                    console.log(error);
                    this.feedbackDialog = true;
                });
            },

            closeFeedbackDialog: function () {
                setTimeout(() => {
                    this.feedbackDialog = false
                }, 3000)
            },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    label {
        font-weight: 500;
        text-decoration-line: underline;
    }

    .listing {
        min-height: 70vh;
    }
    /* a.button_link {
        text-decoration-line: none
    } */
    .listing_header {
        font-size: 1.2em;
        font-weight: normal;
        color: #000;
    }
    .listing_header_secondary {
        font-size: 1em;
        font-weight: normal;
        color: #909090;
    }
    .buyer_download_image {
        width:497px; 
        height:426px; 
        background-image: url('https://www.successionresource.com/wp-content/uploads/2018/05/SRG_Succession-Planning-Case-Study.png'); 
        background-position: right -50px; 
        background-size: contain;
    }
    .view_listing {
        color:#0096a6; 
        font-size: 1.2em; 
        text-transform: uppercase
    }
    #dash_wrapper ul {
        list-style-type: none;
        padding: 0;
    }

    #dash_wrapper li {
        display: inline-block;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }

    #dash_wrapper a {
        color: #9de3ec;
    }

    .listing {
        min-height: 70vh;
    }
 
    .menu_borders {
        border-bottom: 2px solid #FFF
    }


    li.phase_steps {
        list-style-type: none;
        padding: 16px 40px;
        margin: 10px 80px 10px 0;
        border-bottom: 1px solid #CCC;
    }

    li.phase_steps_active {
        color: white;
        background: #0096A6;
        list-style-type: none;
    }
    .active_box_point {
        margin-top: 10px;
        border-bottom: 20px solid #EFEFEF;  /* left arrow slant */
        border-top: 20px solid #EFEFEF; /* right arrow slant */
        border-left: 20px solid #0096A6; /* bottom, add background color here */
    }
    .active_box {
        background-color: #0096a6;
        padding: 8px 120px 8px 40px;
        margin: 10px 0 10px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/BuyerMilestones.vue